export const menuItems = [
  {
    path: "/#listen",
    text: "Listen",
  },
  {
    path: "/#instagram",
    text: "Watch",
  },
  {
    path: "/#contact",
    text: "Contact",
  },
]
